module.exports = __webpack_public_path__ + "static/img/close.d30f018.png";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/imageViewer/icon/close.png
// module id = Ftwu
// module chunks = 100